import React from "react";

// Deterministic decorative QR-style code (NOT a real scannable code).
// Renders a 25x25 module grid with corner finder patterns, seeded by a string.
function hashSeed(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function QrCodeMock({ seed = "whoolive", size = 140 }) {
  const N = 25;
  let state = hashSeed(seed) || 1;
  const rnd = () => {
    state ^= state << 13;
    state ^= state >>> 17;
    state ^= state << 5;
    return (state >>> 0) / 4294967295;
  };

  const isFinder = (r, c) => {
    const inBox = (br, bc) => r >= br && r < br + 7 && c >= bc && c < bc + 7;
    return inBox(0, 0) || inBox(0, N - 7) || inBox(N - 7, 0);
  };
  const finderFill = (r, c) => {
    const rel = (br, bc) => {
      const rr = r - br;
      const cc = c - bc;
      if (rr === 0 || rr === 6 || cc === 0 || cc === 6) return true; // ring
      if (rr >= 2 && rr <= 4 && cc >= 2 && cc <= 4) return true; // center
      return false;
    };
    if (r < 7 && c < 7) return rel(0, 0);
    if (r < 7 && c >= N - 7) return rel(0, N - 7);
    if (r >= N - 7 && c < 7) return rel(N - 7, 0);
    return false;
  };

  const cells = [];
  for (let r = 0; r < N; r++) {
    for (let c = 0; c < N; c++) {
      let fill;
      if (isFinder(r, c)) fill = finderFill(r, c);
      else fill = rnd() > 0.55;
      if (fill) cells.push([c, r]);
    }
  }
  const m = size / N;

  return (
    <svg
      data-testid="qr-code"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="rounded-xl bg-white p-2 shadow-sm ring-1 ring-black/5"
    >
      {cells.map(([c, r], i) => (
        <rect key={i} x={c * m} y={r * m} width={m + 0.4} height={m + 0.4} fill="#0A1526" />
      ))}
    </svg>
  );
}

export default QrCodeMock;
